import './rule-tabs.scss';

import { FaDollarSign, FaPlaneDeparture, FaUsers } from 'react-icons/fa';

import { Button } from '@/components/ui/button';
import { labels } from 'locales/en.label';
import { MdSegment } from 'react-icons/md';
import { NavLink } from 'react-router-dom';

export type Tabs = 'seasons' | 'competitors' | 'rates' | 'autopilot';

interface RuleTabsProps {
	tabsEnabled?: boolean;
	loading?: boolean;
	showDefaultBadges?: boolean;
}

export const RuleTabs = ({
	tabsEnabled = true,
	loading = false,
	showDefaultBadges = false,
}: RuleTabsProps) => {
	return (
		<div className='rule-tabs'>
			<NavLink to='seasons'>
				<Button variant='ghost' tabIndex={-1} disabled={loading}>
					<div className='icon'>
						<MdSegment size={24} />
					</div>
					<div className='label'>{labels.rules.seasons}</div>
				</Button>
			</NavLink>
			<NavLink to='competitors'>
				<Button
					variant='ghost'
					tabIndex={-1}
					disabled={loading || !tabsEnabled}
				>
					<div className='icon'>
						<FaUsers size={24} />
						{showDefaultBadges && <span className='needs-attention-badge' />}
					</div>
					<div className='label'>{labels.rules.competitors}</div>
				</Button>
			</NavLink>
			<NavLink to='rates'>
				<Button
					variant='ghost'
					tabIndex={-1}
					disabled={loading || !tabsEnabled}
				>
					<div className='icon'>
						<FaDollarSign size={24} />
						{showDefaultBadges && <span className='needs-attention-badge' />}
					</div>
					<div className='label'>{labels.rules.rates}</div>
				</Button>
			</NavLink>
			<NavLink to='autopilot'>
				<Button
					variant='ghost'
					tabIndex={-1}
					disabled={loading || !tabsEnabled}
				>
					<div className='icon'>
						<FaPlaneDeparture size={24} />
						{showDefaultBadges && <span className='needs-attention-badge' />}
					</div>
					<div className='label'>{labels.rules.autopilot}</div>
				</Button>
			</NavLink>
		</div>
	);
};
